/*eslint no-script-url: 0 */
import React, { Component } from "react";
import QuickMenu from './Components/Footer/QuickMenu';
import OtherMenu from './Components/Footer/OtherMenu';
import ContactUs from './Components/Footer/ContactUs';

class Footer extends Component {
  	render() {
	    return (
	    	<div>
		    	<footer className="full_width">
					<div className="container">
						<div className="row">
							<QuickMenu />
							<OtherMenu />
							<ContactUs />
						</div>
					</div>
				</footer>
				<div className="footer_bot full_width">
					<div className="container">
						<p> &copy; {new Date().getFullYear()} Just Picture Framing Online. </p>
					</div>
				</div>
			</div>
	    );
  	}
}

export default Footer;